"use strict";

var parse5 = require("parse5");

var documentAdapter = require("./documentAdapter");

var NODE_TYPE = require("../living/node-type");

var idlUtils = require("../living/generated/utils");

var serializer = new parse5.TreeSerializer(documentAdapter);

exports.domToHtml = function (iterable) {
  var ret = "";
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = iterable[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var node = _step.value;

      if (node.nodeType === NODE_TYPE.DOCUMENT_NODE) {
        ret += serializer.serialize(node);
      } else {
        ret += serializer.serialize({
          childNodes: [idlUtils.wrapperForImpl(node)]
        });
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return != null) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return ret;
};